var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CollectionsIcon from "@mui/icons-material/Collections";
import ForumIcon from "@mui/icons-material/Forum";
import InstagramIcon from "@mui/icons-material/Instagram";
import LanguageIcon from "@mui/icons-material/Language";
import ListAltIcon from "@mui/icons-material/ListAlt";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import TwitterIcon from "@mui/icons-material/Twitter";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Alert, Avatar, Box, Breadcrumbs, Button, Chip, CircularProgress, FormControl, FormControlLabel, FormHelperText, IconButton, InputAdornment, InputLabel, MenuItem, Select, Step, StepLabel, Stepper, Switch, TextField, Tooltip, Typography, } from "@mui/material";
import ImageCropModal from "components/profile/Header/subcomponets/profileModalMenu/subcomponets/ImageCropModal";
import { T, FONT } from "features/admin/admin.theme";
import { useAuctionsByCollection, useCreateAuction, } from "features/admin/auctions/model/hooks";
import { useAdminCoins } from "features/admin/coins/model/hooks/useAdminCoins";
import { JobProgress, useEnqueueJob } from "features/admin/jobs";
import { AdminDateTimeField } from "features/admin/ui/admin-date-time-field";
import useToastQueue from "hooks/useToastQueue";
import { useNavigate, useParams } from "react-router";
import ToastStack from "shared/ui/toast-stack/toast-stack";
import { AboutDraftEditor, AboutEditor, aboutAdminApi, EMPTY_ABOUT, } from "../../about";
import { collectionsAdminApi } from "../../api/collectionsAdminApi";
import { useAdminCollection, useCreateCollection, useUpdateCollection, } from "../../model/hooks";
import { ADMIN_IMAGE_ACCEPT, ADMIN_IMAGE_ERROR, isAllowedAdminImage, } from "../../model/imageFormats";
import { COLLECTION_CATEGORIES, COLLECTION_REGIONS } from "../../model/types/collection.types";
import { nftsAdminApi } from "../../nfts/api/nftsAdminApi";
import { CreatorSelect } from "./CreatorSelect";
// ── Design tokens ─────────────────────────────────────────────────────────────
var ACCENT = T.accent;
var ACCENT_BG = T.accentTint;
var ACCENT_BORDER = T.accentTintStrong;
var BG_CARD = T.surface;
var BORDER = T.border;
var SUCCESS = T.success;
var ERROR = T.danger;
var CHAIN_COLORS = {
    bsc: "#f0b90b",
    ethereum: "#627eea",
    polygon: "#8247e5",
    solana: "#9945ff",
    base: "#0052ff",
};
var STEPS = ["Детали", "Медиа", "Соцсети", "About", "Items", "Аукцион", "Публикация"];
var DEFAULT_FORM = {
    name: "",
    slug: "",
    creatorId: null,
    creatorName: "",
    creatorVerified: false,
    royaltyPercent: "",
    paymentCoinId: "",
    blockchain: "bsc",
    contractAddress: "",
    tokenStandard: "ERC-721",
    mintDate: "",
    totalSupply: "",
    category: "residential",
    region: "",
    country: "",
    latitude: "",
    longitude: "",
    type: "AUCTION",
    verified: false,
    description: "",
    website: "",
    twitter: "",
    discord: "",
    instagram: "",
    aboutBlocks: [],
    createAuction: false,
    auctionData: {
        description: "",
        settlementModel: "highest-first-time-priority",
        rules: [],
        minBidUsd: "",
        publicSalePriceUsd: "",
        totalSupply: "",
        allocationPerBidderMax: "1",
        startsAt: "",
        endsAt: "",
        paymentMethods: ["QUANTA"],
        startNow: false,
    },
};
// ── Shared input style ────────────────────────────────────────────────────────
var inputSx = {
    "& .MuiOutlinedInput-root": {
        background: "rgba(255,255,255,0.02)",
        borderRadius: "12px",
        color: "#fff",
        "& fieldset": { borderColor: BORDER },
        "&:hover fieldset": { borderColor: ACCENT_BORDER },
        "&.Mui-focused fieldset": {
            borderColor: ACCENT,
            boxShadow: "0 0 0 3px ".concat(ACCENT_BG),
        },
        "& input": { color: "#fff" },
        "& textarea": { color: "#fff" },
    },
    "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.45)" },
    "& .MuiInputLabel-root.Mui-focused": { color: ACCENT },
    "& .MuiSelect-select": { color: "#fff" },
    "& .MuiSelect-icon": { color: "rgba(255,255,255,0.4)" },
    "& .MuiFormHelperText-root": { color: "rgba(255,255,255,0.4)" },
    "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.35)", opacity: 1 },
};
var menuPaperSx = {
    background: "#1a2235",
    border: "1px solid ".concat(BORDER),
    maxWidth: "calc(100vw - 32px)",
    "& .MuiMenuItem-root": {
        color: "#fff",
        whiteSpace: "normal",
        wordBreak: "break-word",
        "&:hover": { background: ACCENT_BG },
        "&.Mui-selected": { background: ACCENT_BG },
        "&.Mui-selected:hover": { background: ACCENT_BG },
    },
};
// ── Live Preview Card ─────────────────────────────────────────────────────────
var LivePreview = function (_a) {
    var _b;
    var form = _a.form, bannerPreview = _a.bannerPreview, logoPreview = _a.logoPreview;
    var chainColor = (_b = CHAIN_COLORS[form.blockchain]) !== null && _b !== void 0 ? _b : ACCENT;
    return (_jsxs(Box, { sx: {
            background: BG_CARD,
            border: "1px solid ".concat(BORDER),
            borderRadius: "20px",
            overflow: "hidden",
            transition: "box-shadow 300ms",
            "&:hover": { boxShadow: "0 8px 32px rgba(255,184,1,0.12)" },
        }, children: [_jsxs(Box, { sx: {
                    height: 130,
                    background: bannerPreview
                        ? "url(".concat(bannerPreview, ") center/cover no-repeat")
                        : "linear-gradient(135deg, #1a2540 0%, #0d1629 100%)",
                    position: "relative",
                    display: "flex",
                    alignItems: "flex-end",
                    px: 2,
                }, children: [!bannerPreview && (_jsx(Box, { sx: {
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            opacity: 0.25,
                        }, children: _jsx(AddPhotoAlternateIcon, { sx: { fontSize: 36, color: "#fff" } }) })), _jsx(Avatar, { src: logoPreview !== null && logoPreview !== void 0 ? logoPreview : undefined, sx: {
                            width: 60,
                            height: 60,
                            border: "3px solid ".concat(BG_CARD),
                            background: ACCENT_BG,
                            position: "relative",
                            zIndex: 1,
                            mb: -4,
                        }, children: _jsx(CollectionsIcon, { sx: { color: ACCENT, fontSize: 26 } }) })] }), _jsxs(Box, { sx: { px: 2, pt: 5.5, pb: 2.5 }, children: [_jsxs(Box, { display: "flex", alignItems: "center", gap: 0.75, mb: 0.5, children: [_jsx(Typography, { sx: {
                                    fontWeight: 700,
                                    fontSize: 16,
                                    color: "#fff",
                                    flex: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }, children: form.name || "Collection Name" }), form.verified && (_jsx(VerifiedIcon, { sx: { fontSize: 18, color: ACCENT, flexShrink: 0 } }))] }), _jsxs(Box, { display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1, children: [_jsx(Chip, { label: form.blockchain, size: "small", sx: {
                                    background: "".concat(chainColor, "1a"),
                                    color: chainColor,
                                    border: "1px solid ".concat(chainColor, "40"),
                                    fontSize: 10,
                                    height: 20,
                                    textTransform: "capitalize",
                                } }), _jsx(Chip, { label: form.tokenStandard || "ERC-721", size: "small", sx: {
                                    background: ACCENT_BG,
                                    color: ACCENT,
                                    border: "1px solid ".concat(ACCENT_BORDER),
                                    fontSize: 10,
                                    height: 20,
                                } })] }), _jsxs(Typography, { sx: { color: "rgba(255,255,255,0.3)", fontSize: 11, mt: 1.5, fontFamily: "monospace" }, children: ["/", form.slug || "collection-slug"] })] })] }));
};
var StepBasicInfo = function (_a) {
    var form = _a.form, setForm = _a.setForm, slugStatus = _a.slugStatus, setSlugStatus = _a.setSlugStatus, collectionId = _a.collectionId;
    var slugTimerRef = useRef(null);
    var _b = useAdminCoins(), coins = _b.data, coinsLoading = _b.isLoading;
    var coinList = coins !== null && coins !== void 0 ? coins : [];
    var paymentCoinMissing = !form.paymentCoinId;
    var handleSlugChange = function (val) {
        var clean = val
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "")
            .replace(/-+/g, "-")
            .replace(/^-/, "");
        setForm(function (f) { return (__assign(__assign({}, f), { slug: clean })); });
        setSlugStatus("idle");
        if (slugTimerRef.current)
            clearTimeout(slugTimerRef.current);
        if (clean.length >= 2) {
            setSlugStatus("checking");
            slugTimerRef.current = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                var available, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, collectionsAdminApi.checkSlug(clean, collectionId)];
                        case 1:
                            available = (_b.sent()).available;
                            setSlugStatus(available ? "available" : "taken");
                            return [3 /*break*/, 3];
                        case 2:
                            _a = _b.sent();
                            setSlugStatus("idle");
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }, 600);
        }
    };
    var setField = function (k) {
        return function (e) {
            return setForm(function (f) {
                var _a;
                return (__assign(__assign({}, f), (_a = {}, _a[k] = e.target.value, _a)));
            });
        };
    };
    var slugEndAdornment = function () {
        if (slugStatus === "checking")
            return _jsx(CircularProgress, { size: 14, sx: { color: "rgba(255,255,255,0.4)" } });
        if (slugStatus === "available")
            return _jsx(CheckCircleIcon, { sx: { fontSize: 16, color: SUCCESS } });
        if (slugStatus === "taken")
            return (_jsx(Box, { sx: { width: 8, height: 8, borderRadius: "50%", background: ERROR, flexShrink: 0 } }));
        return null;
    };
    var adornment = slugEndAdornment();
    return (_jsxs(Box, { sx: {
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: { xs: 2.25, sm: 3 },
        }, children: [_jsx(TextField, { fullWidth: true, label: "Collection Name", placeholder: "Enter collection name", value: form.name, onChange: setField("name"), sx: __assign(__assign({}, inputSx), { gridColumn: "1 / -1" }) }), _jsx(TextField, { fullWidth: true, label: "Slug", placeholder: "my-collection", value: form.slug, onChange: function (e) { return handleSlugChange(e.target.value); }, helperText: slugStatus === "available"
                    ? "Slug is available"
                    : slugStatus === "taken"
                        ? "Slug already exists"
                        : " ", slotProps: {
                    formHelperText: {
                        sx: {
                            color: slugStatus === "available"
                                ? SUCCESS
                                : slugStatus === "taken"
                                    ? ERROR
                                    : "transparent",
                            fontSize: 11,
                            mt: 0.5,
                        },
                    },
                    input: {
                        endAdornment: adornment ? (_jsx(InputAdornment, { position: "end", children: adornment })) : undefined,
                    },
                }, sx: inputSx }), _jsxs(FormControl, { fullWidth: true, sx: inputSx, children: [_jsx(InputLabel, { children: "Blockchain" }), _jsx(Select, { label: "Blockchain", value: form.blockchain, onChange: function (e) {
                            return setForm(function (f) { return (__assign(__assign({}, f), { blockchain: e.target.value })); });
                        }, MenuProps: { PaperProps: { sx: menuPaperSx } }, children: _jsx(MenuItem, { value: "bsc", children: "BSC" }) })] }), _jsx(CreatorSelect, { valueId: form.creatorId, valueName: form.creatorName, onChange: function (_a) {
                    var id = _a.id, name = _a.name;
                    return setForm(function (f) { return (__assign(__assign({}, f), { creatorId: id, creatorName: name })); });
                }, inputSx: inputSx }), _jsx(TextField, { fullWidth: true, type: "number", label: "\u0420\u043E\u044F\u043B\u0442\u0438 \u0430\u0432\u0442\u043E\u0440\u0430, %", placeholder: "\u043D\u0430\u043F\u0440. 5", value: form.royaltyPercent, onChange: function (e) {
                    var raw = e.target.value;
                    if (raw === "") {
                        setForm(function (f) { return (__assign(__assign({}, f), { royaltyPercent: "" })); });
                        return;
                    }
                    var n = Math.min(10, Math.max(0, Number(raw)));
                    setForm(function (f) { return (__assign(__assign({}, f), { royaltyPercent: Number.isFinite(n) ? String(n) : "" })); });
                }, inputProps: { min: 0, max: 10, step: 0.5 }, helperText: "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0430\u0432\u0442\u043E\u0440 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u0441 \u043A\u0430\u0436\u0434\u043E\u0439 \u043F\u0440\u043E\u0434\u0430\u0436\u0438 NFT (0\u201310%). \u0417\u0430\u0447\u0438\u0441\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u0435\u0433\u043E \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441.", sx: inputSx }), _jsxs(FormControl, { fullWidth: true, required: true, error: paymentCoinMissing, sx: __assign(__assign({}, inputSx), { gridColumn: "1 / -1" }), children: [_jsx(InputLabel, { children: "\u0422\u043E\u043A\u0435\u043D \u043E\u043F\u043B\u0430\u0442\u044B" }), _jsxs(Select, { label: "\u0422\u043E\u043A\u0435\u043D \u043E\u043F\u043B\u0430\u0442\u044B", value: coinList.some(function (c) { return c.id === form.paymentCoinId; }) ? form.paymentCoinId : "", onChange: function (e) { return setForm(function (f) { return (__assign(__assign({}, f), { paymentCoinId: e.target.value })); }); }, disabled: coinsLoading, MenuProps: { PaperProps: { sx: menuPaperSx } }, children: [coinsLoading && (_jsx(MenuItem, { value: "", disabled: true, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043C\u043E\u043D\u0435\u0442\u2026" })), !coinsLoading && coinList.length === 0 && (_jsx(MenuItem, { value: "", disabled: true, children: "\u041C\u043E\u043D\u0435\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" })), coinList.map(function (coin) { return (_jsx(MenuItem, { value: coin.id, children: "".concat(coin.symbol, " \u2014 ").concat(coin.name) }, coin.id)); })] }), _jsx(FormHelperText, { sx: { color: paymentCoinMissing ? ERROR : "rgba(255,255,255,0.4)" }, children: paymentCoinMissing
                            ? "Выберите токен оплаты — обязательное поле"
                            : "Все NFT этой коллекции продаются и торгуются только в этом токене" })] }), _jsxs(Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    background: "rgba(255,255,255,0.02)",
                    border: "1px solid ".concat(form.creatorVerified ? ACCENT_BORDER : BORDER),
                    borderRadius: "12px",
                    px: 2,
                    py: 1.5,
                    transition: "border-color 200ms, box-shadow 200ms",
                    boxShadow: form.creatorVerified ? "0 0 0 3px ".concat(ACCENT_BG) : "none",
                }, children: [_jsxs(Box, { flex: 1, children: [_jsx(Typography, { sx: { color: "#fff", fontWeight: 600, fontSize: 14 }, children: "Creator verified" }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.4)", fontSize: 12, mt: 0.25 }, children: "Adds a verified checkmark next to the creator name on the public page" })] }), _jsx(FormControlLabel, { control: _jsx(Switch, { checked: form.creatorVerified, onChange: function (e) {
                                return setForm(function (f) { return (__assign(__assign({}, f), { creatorVerified: e.target.checked })); });
                            }, sx: {
                                "& .MuiSwitch-switchBase.Mui-checked": { color: ACCENT },
                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                    background: ACCENT,
                                },
                            } }), label: "", sx: { m: 0 } })] }), _jsx(TextField, { fullWidth: true, label: "Total Supply (unique items)", type: "number", placeholder: "e.g. 10000", value: form.totalSupply, onChange: setField("totalSupply"), helperText: "Maximum number of unique NFTs this collection will ever contain", sx: inputSx }), _jsxs(FormControl, { fullWidth: true, sx: inputSx, children: [_jsx(InputLabel, { children: "Category" }), _jsx(Select, { label: "Category", value: form.category, onChange: function (e) {
                            return setForm(function (f) { return (__assign(__assign({}, f), { category: e.target.value })); });
                        }, MenuProps: { PaperProps: { sx: menuPaperSx } }, children: COLLECTION_CATEGORIES.map(function (c) { return (_jsx(MenuItem, { value: c.value, children: c.label }, c.value)); }) })] }), _jsxs(FormControl, { fullWidth: true, sx: inputSx, children: [_jsx(InputLabel, { children: "Region" }), _jsxs(Select, { label: "Region", value: form.region, onChange: function (e) {
                            return setForm(function (f) { return (__assign(__assign({}, f), { region: e.target.value })); });
                        }, MenuProps: { PaperProps: { sx: menuPaperSx } }, children: [_jsx(MenuItem, { value: "", children: "\u2014" }), COLLECTION_REGIONS.map(function (r) { return (_jsx(MenuItem, { value: r.value, children: r.label }, r.value)); })] })] }), _jsx(TextField, { fullWidth: true, label: "Country", value: form.country, onChange: function (e) { return setForm(function (f) { return (__assign(__assign({}, f), { country: e.target.value })); }); }, sx: inputSx }), _jsxs(Box, { sx: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }, children: [_jsx(TextField, { type: "number", label: "Latitude (\u043E\u043F\u0446.)", value: form.latitude, onChange: function (e) { return setForm(function (f) { return (__assign(__assign({}, f), { latitude: e.target.value })); }); }, helperText: "\u0415\u0441\u043B\u0438 \u0437\u0430\u0434\u0430\u043D\u044B \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B \u2014 \u0440\u0435\u0433\u0438\u043E\u043D \u0438 \u0441\u0442\u0440\u0430\u043D\u0430 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438", sx: inputSx }), _jsx(TextField, { type: "number", label: "Longitude (\u043E\u043F\u0446.)", value: form.longitude, onChange: function (e) { return setForm(function (f) { return (__assign(__assign({}, f), { longitude: e.target.value })); }); }, sx: inputSx })] }), _jsxs(FormControl, { fullWidth: true, sx: inputSx, children: [_jsx(InputLabel, { children: "Type" }), _jsxs(Select, { label: "Type", value: form.type, onChange: function (e) {
                            return setForm(function (f) { return (__assign(__assign({}, f), { type: e.target.value })); });
                        }, MenuProps: { PaperProps: { sx: menuPaperSx } }, children: [_jsx(MenuItem, { value: "AUCTION", children: "Auction" }), _jsx(MenuItem, { value: "PAST_AUCTION", children: "Past Auction" }), _jsx(MenuItem, { value: "VANISH", children: "Vanish" })] })] }), _jsxs(Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    background: "rgba(255,255,255,0.02)",
                    border: "1px solid ".concat(form.verified ? ACCENT_BORDER : BORDER),
                    borderRadius: "12px",
                    px: 2,
                    py: 1.5,
                    transition: "border-color 200ms, box-shadow 200ms",
                    boxShadow: form.verified ? "0 0 0 3px ".concat(ACCENT_BG) : "none",
                }, children: [_jsxs(Box, { flex: 1, children: [_jsx(Typography, { sx: { color: "#fff", fontWeight: 600, fontSize: 14 }, children: "Verified" }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.4)", fontSize: 12, mt: 0.25 }, children: "Mark this collection as verified" })] }), _jsx(FormControlLabel, { control: _jsx(Switch, { checked: form.verified, onChange: function (e) { return setForm(function (f) { return (__assign(__assign({}, f), { verified: e.target.checked })); }); }, sx: {
                                "& .MuiSwitch-switchBase.Mui-checked": { color: ACCENT },
                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                    background: ACCENT,
                                },
                            } }), label: "", sx: { m: 0 } })] })] }));
};
// ── Step 2: Media ─────────────────────────────────────────────────────────────
var StepMedia = function (_a) {
    var form = _a.form, bannerPreview = _a.bannerPreview, setBannerFile = _a.setBannerFile, setBannerPreview = _a.setBannerPreview, logoPreview = _a.logoPreview, setLogoFile = _a.setLogoFile, setLogoPreview = _a.setLogoPreview, onInvalidImage = _a.onInvalidImage;
    var _b = useState(false), bannerDragging = _b[0], setBannerDragging = _b[1];
    var _c = useState(null), cropSrc = _c[0], setCropSrc = _c[1];
    var _d = useState(null), cropTarget = _d[0], setCropTarget = _d[1];
    var bannerInputRef = useRef(null);
    var logoInputRef = useRef(null);
    var openCrop = function (file, target) {
        setCropSrc(URL.createObjectURL(file));
        setCropTarget(target);
    };
    var handleCropClose = function () {
        if (cropSrc)
            URL.revokeObjectURL(cropSrc);
        setCropSrc(null);
        setCropTarget(null);
    };
    var handleCropApply = function (file, localUrl) {
        if (cropTarget === "banner") {
            setBannerFile(file);
            setBannerPreview(localUrl);
        }
        else {
            setLogoFile(file);
            setLogoPreview(localUrl);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: { display: "grid", gridTemplateColumns: "1fr 320px", gap: 3, alignItems: "start" }, children: [_jsxs(Box, { sx: { display: "flex", flexDirection: "column", gap: 3 }, children: [_jsxs(Box, { children: [_jsx(Typography, { sx: { color: "rgba(255,255,255,0.65)", fontWeight: 600, fontSize: 13, mb: 1.5 }, children: "Banner Image" }), bannerPreview ? (_jsxs(Box, { sx: { position: "relative", borderRadius: "16px", overflow: "hidden" }, children: [_jsx("img", { src: bannerPreview, alt: "Banner preview", style: { width: "100%", height: 190, objectFit: "cover", display: "block" } }), _jsxs(Box, { sx: { position: "absolute", top: 10, right: 10, display: "flex", gap: 1 }, children: [_jsx(Button, { size: "small", onClick: function () { var _a; return (_a = bannerInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, sx: {
                                                            background: "rgba(0,0,0,0.65)",
                                                            color: "#fff",
                                                            borderRadius: "8px",
                                                            fontSize: 11,
                                                            backdropFilter: "blur(8px)",
                                                            "&:hover": { background: "rgba(0,0,0,0.85)" },
                                                        }, children: "Replace" }), _jsx(Button, { size: "small", onClick: function () { setBannerFile(null); setBannerPreview(null); }, sx: {
                                                            background: "rgba(239,68,68,0.75)",
                                                            color: "#fff",
                                                            borderRadius: "8px",
                                                            fontSize: 11,
                                                            backdropFilter: "blur(8px)",
                                                            "&:hover": { background: "rgba(239,68,68,0.95)" },
                                                        }, children: "Remove" })] })] })) : (_jsxs(Box, { onDragOver: function (e) { e.preventDefault(); setBannerDragging(true); }, onDragLeave: function () { return setBannerDragging(false); }, onDrop: function (e) {
                                            e.preventDefault();
                                            setBannerDragging(false);
                                            var file = e.dataTransfer.files[0];
                                            if (file && isAllowedAdminImage(file))
                                                openCrop(file, "banner");
                                            else if (file)
                                                onInvalidImage();
                                        }, onClick: function () { var _a; return (_a = bannerInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, sx: {
                                            height: 190,
                                            borderRadius: "16px",
                                            border: "2px dashed ".concat(bannerDragging ? ACCENT : BORDER),
                                            background: bannerDragging ? ACCENT_BG : "rgba(255,255,255,0.01)",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 1.5,
                                            cursor: "pointer",
                                            transition: "all 200ms",
                                            "&:hover": { borderColor: ACCENT_BORDER, background: ACCENT_BG },
                                        }, children: [_jsx(AddPhotoAlternateIcon, { sx: { fontSize: 38, color: bannerDragging ? ACCENT : "rgba(255,255,255,0.2)" } }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.5)", fontSize: 14 }, children: "Drag & Drop Banner Image" }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.25)", fontSize: 12 }, children: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F 1500 \u00D7 400 px \u00B7 PNG \u0438\u043B\u0438 JPG" })] })), _jsx("input", { ref: bannerInputRef, type: "file", accept: ADMIN_IMAGE_ACCEPT, style: { display: "none" }, onChange: function (e) {
                                            var _a;
                                            var f = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                                            if (f)
                                                openCrop(f, "banner");
                                            e.target.value = "";
                                        } })] }), _jsxs(Box, { children: [_jsx(Typography, { sx: { color: "rgba(255,255,255,0.65)", fontWeight: 600, fontSize: 13, mb: 1.5 }, children: "Collection Logo" }), _jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 3 }, children: [_jsxs(Box, { sx: {
                                                    position: "relative",
                                                    cursor: "pointer",
                                                    "&:hover .logo-overlay": { opacity: 1 },
                                                }, onClick: function () { var _a; return (_a = logoInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: [_jsx(Avatar, { src: logoPreview !== null && logoPreview !== void 0 ? logoPreview : undefined, sx: {
                                                            width: 100,
                                                            height: 100,
                                                            border: logoPreview ? "3px solid ".concat(ACCENT) : "2px dashed ".concat(BORDER),
                                                            background: "rgba(255,255,255,0.02)",
                                                            boxShadow: logoPreview ? "0 0 20px rgba(255,184,1,0.3)" : "none",
                                                            transition: "all 200ms",
                                                        }, children: _jsx(AddPhotoAlternateIcon, { sx: { fontSize: 28, color: "rgba(255,255,255,0.25)" } }) }), _jsx(Box, { className: "logo-overlay", sx: {
                                                            position: "absolute",
                                                            inset: 0,
                                                            borderRadius: "50%",
                                                            background: "rgba(0,0,0,0.5)",
                                                            backdropFilter: "blur(4px)",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            opacity: 0,
                                                            transition: "opacity 200ms",
                                                        }, children: _jsx(SwapHorizIcon, { sx: { color: "#fff", fontSize: 22 } }) })] }), _jsxs(Box, { children: [_jsx(Typography, { sx: { color: "rgba(255,255,255,0.55)", fontSize: 13 }, children: "Click to upload logo" }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.3)", fontSize: 12, mt: 0.5 }, children: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F 350 \u00D7 350 px \u00B7 PNG \u0438\u043B\u0438 JPG" }), logoPreview && (_jsx(Button, { size: "small", onClick: function () { setLogoFile(null); setLogoPreview(null); }, sx: {
                                                            mt: 1,
                                                            color: ERROR,
                                                            p: 0,
                                                            minWidth: 0,
                                                            fontSize: 12,
                                                            textTransform: "none",
                                                            "&:hover": { background: "none", textDecoration: "underline" },
                                                        }, children: "Remove" }))] })] }), _jsx("input", { ref: logoInputRef, type: "file", accept: ADMIN_IMAGE_ACCEPT, style: { display: "none" }, onChange: function (e) {
                                            var _a;
                                            var f = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                                            if (f)
                                                openCrop(f, "logo");
                                            e.target.value = "";
                                        } })] })] }), _jsxs(Box, { children: [_jsx(Typography, { sx: { color: "rgba(255,255,255,0.65)", fontWeight: 600, fontSize: 13, mb: 1.5 }, children: "Live Preview" }), _jsx(LivePreview, { form: form, bannerPreview: bannerPreview, logoPreview: logoPreview })] })] }), cropSrc && cropTarget && (_jsx(ImageCropModal, { open: true, imageSrc: cropSrc, aspect: cropTarget === "banner" ? 1500 / 400 : 1, shape: cropTarget === "banner" ? "rect" : "round", outputType: cropTarget === "banner" ? "banner" : "avatar", onClose: handleCropClose, onApply: handleCropApply }))] }));
};
// ── Step 3: Socials ───────────────────────────────────────────────────────────
var StepSocials = function (_a) {
    var form = _a.form, setForm = _a.setForm;
    var setField = function (k) { return function (e) {
        return setForm(function (f) {
            var _a;
            return (__assign(__assign({}, f), (_a = {}, _a[k] = e.target.value, _a)));
        });
    }; };
    return (_jsxs(Box, { sx: { display: "flex", flexDirection: "column", gap: 2.5 }, children: [_jsx(TextField, { fullWidth: true, label: "Website", placeholder: "https://yourproject.com", value: form.website, onChange: setField("website"), slotProps: {
                    input: {
                        startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(LanguageIcon, { sx: { color: "rgba(255,255,255,0.3)", fontSize: 18 } }) })),
                    },
                }, sx: inputSx }), _jsx(TextField, { fullWidth: true, label: "Twitter / X", placeholder: "@handle", value: form.twitter, onChange: setField("twitter"), slotProps: {
                    input: {
                        startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(TwitterIcon, { sx: { color: "rgba(255,255,255,0.3)", fontSize: 18 } }) })),
                    },
                }, sx: inputSx }), _jsx(TextField, { fullWidth: true, label: "Discord", placeholder: "discord.gg/invite", value: form.discord, onChange: setField("discord"), slotProps: {
                    input: {
                        startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(ForumIcon, { sx: { color: "rgba(255,255,255,0.3)", fontSize: 18 } }) })),
                    },
                }, sx: inputSx }), _jsx(TextField, { fullWidth: true, label: "Instagram", placeholder: "@handle", value: form.instagram, onChange: setField("instagram"), slotProps: {
                    input: {
                        startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(InstagramIcon, { sx: { color: "rgba(255,255,255,0.3)", fontSize: 18 } }) })),
                    },
                }, sx: inputSx })] }));
};
// ── Step 4: About — Rich block editor ────────────────────────────────────────
var fileToDataUrl = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};
var AboutBlockCard = function (_a) {
    var _b, _c, _d;
    var block = _a.block, index = _a.index, total = _a.total, onChange = _a.onChange, onRemove = _a.onRemove, onMoveUp = _a.onMoveUp, onMoveDown = _a.onMoveDown, onDragStart = _a.onDragStart, onDragOver = _a.onDragOver, onDrop = _a.onDrop, dragOver = _a.dragOver;
    var handleImage = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAllowedAdminImage(file))
                        return [2 /*return*/];
                    return [4 /*yield*/, fileToDataUrl(file)];
                case 1:
                    url = _a.sent();
                    onChange(__assign(__assign({}, block), { imageUrl: url }));
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Box, { draggable: true, onDragStart: onDragStart, onDragOver: function (e) {
            e.preventDefault();
            onDragOver();
        }, onDrop: function (e) {
            e.preventDefault();
            onDrop();
        }, sx: {
            background: dragOver ? ACCENT_BG : "rgba(255,255,255,0.02)",
            border: "1px solid ".concat(dragOver ? ACCENT : BORDER),
            borderRadius: "12px",
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            transition: "border-color 180ms",
            cursor: "grab",
            "&:active": { cursor: "grabbing" },
        }, children: [_jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [_jsx(Box, { sx: {
                            color: "rgba(255,255,255,0.3)",
                            fontSize: 18,
                            fontWeight: 700,
                            cursor: "grab",
                            userSelect: "none",
                        }, children: "\u22EE\u22EE" }), _jsx(FormControl, { size: "small", sx: __assign(__assign({}, inputSx), { minWidth: 130 }), children: _jsxs(Select, { value: block.type, onChange: function (e) {
                                return onChange(__assign(__assign({}, block), { type: e.target.value }));
                            }, MenuProps: { PaperProps: { sx: menuPaperSx } }, children: [_jsx(MenuItem, { value: "text", children: "Text block" }), _jsx(MenuItem, { value: "image", children: "Image block" }), _jsx(MenuItem, { value: "hero", children: "Hero (title + bg)" }), _jsx(MenuItem, { value: "info-list", children: "Info list (key/value cards)" }), _jsx(MenuItem, { value: "feature-cards", children: "Feature cards (3 mini cards)" }), _jsx(MenuItem, { value: "gallery", children: "Gallery (image cards)" })] }) }), _jsxs(Typography, { sx: { color: "rgba(255,255,255,0.35)", fontSize: 11, flex: 1 }, children: ["Block #", index + 1] }), _jsx(IconButton, { size: "small", onClick: onMoveUp, disabled: index === 0, sx: { color: "rgba(255,255,255,0.4)", "&.Mui-disabled": { opacity: 0.2 } }, children: "\u2191" }), _jsx(IconButton, { size: "small", onClick: onMoveDown, disabled: index === total - 1, sx: { color: "rgba(255,255,255,0.4)", "&.Mui-disabled": { opacity: 0.2 } }, children: "\u2193" }), _jsx(IconButton, { size: "small", onClick: onRemove, sx: {
                            color: "rgba(255,255,255,0.4)",
                            "&:hover": { color: "#EF4444", background: "rgba(239,68,68,0.1)" },
                        }, children: "\u2715" })] }), _jsx(TextField, { fullWidth: true, size: "small", label: "Title", value: block.title, onChange: function (e) { return onChange(__assign(__assign({}, block), { title: e.target.value })); }, sx: inputSx }), (block.type === "text" ||
                block.type === "hero" ||
                block.type === "info-list" ||
                block.type === "feature-cards" ||
                block.type === "gallery") && (_jsx(TextField, { fullWidth: true, size: "small", label: block.type === "info-list" || block.type === "feature-cards" || block.type === "gallery"
                    ? "Section intro (optional)"
                    : "Body", multiline: true, rows: 3, value: block.body, onChange: function (e) { return onChange(__assign(__assign({}, block), { body: e.target.value })); }, sx: inputSx })), (block.type === "info-list" ||
                block.type === "feature-cards" ||
                block.type === "gallery") && (_jsxs(Box, { children: [_jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1, children: [_jsxs(Typography, { sx: { color: "rgba(255,255,255,0.55)", fontSize: 12 }, children: [((_b = block.items) !== null && _b !== void 0 ? _b : []).length, " card", ((_c = block.items) !== null && _c !== void 0 ? _c : []).length === 1 ? "" : "s"] }), _jsx(Button, { size: "small", onClick: function () {
                                    var _a;
                                    return onChange(__assign(__assign({}, block), { items: __spreadArray(__spreadArray([], ((_a = block.items) !== null && _a !== void 0 ? _a : []), true), [
                                            { id: crypto.randomUUID(), title: "", description: "", caption: "", imageUrl: null },
                                        ], false) }));
                                }, sx: {
                                    color: ACCENT,
                                    border: "1px solid ".concat(ACCENT_BORDER),
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontSize: 11,
                                    "&:hover": { borderColor: ACCENT, background: ACCENT_BG },
                                }, children: "+ Add card" })] }), _jsx(Box, { display: "flex", flexDirection: "column", gap: 1, children: ((_d = block.items) !== null && _d !== void 0 ? _d : []).map(function (item, idx) {
                            var _a, _b, _c, _d;
                            return (_jsxs(Box, { sx: {
                                    background: "rgba(255,255,255,0.02)",
                                    border: "1px solid ".concat(BORDER),
                                    borderRadius: "10px",
                                    p: 1.5,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                }, children: [_jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [_jsxs(Typography, { sx: { color: "rgba(255,255,255,0.4)", fontSize: 11 }, children: ["Card #", idx + 1] }), _jsx(Button, { size: "small", onClick: function () {
                                                    var _a;
                                                    return onChange(__assign(__assign({}, block), { items: ((_a = block.items) !== null && _a !== void 0 ? _a : []).filter(function (_, i) { return i !== idx; }) }));
                                                }, sx: {
                                                    minWidth: 0,
                                                    color: "rgba(255,255,255,0.4)",
                                                    "&:hover": { color: "#EF4444", background: "rgba(239,68,68,0.1)" },
                                                }, children: "\u2715" })] }), block.type === "info-list" && (_jsx(TextField, { size: "small", placeholder: "Caption (e.g. \u0424\u041E\u0420\u041C\u0410\u0422)", value: (_a = item.caption) !== null && _a !== void 0 ? _a : "", onChange: function (e) {
                                            var _a;
                                            return onChange(__assign(__assign({}, block), { items: ((_a = block.items) !== null && _a !== void 0 ? _a : []).map(function (it, i) {
                                                    return i === idx ? __assign(__assign({}, it), { caption: e.target.value }) : it;
                                                }) }));
                                        }, sx: inputSx })), _jsx(TextField, { size: "small", placeholder: block.type === "info-list" ? "Title (e.g. Residential Collection)" : "Title", value: (_b = item.title) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                                            var _a;
                                            return onChange(__assign(__assign({}, block), { items: ((_a = block.items) !== null && _a !== void 0 ? _a : []).map(function (it, i) {
                                                    return i === idx ? __assign(__assign({}, it), { title: e.target.value }) : it;
                                                }) }));
                                        }, sx: inputSx }), _jsx(TextField, { size: "small", placeholder: "Description", multiline: true, rows: 2, value: (_c = item.description) !== null && _c !== void 0 ? _c : "", onChange: function (e) {
                                            var _a;
                                            return onChange(__assign(__assign({}, block), { items: ((_a = block.items) !== null && _a !== void 0 ? _a : []).map(function (it, i) {
                                                    return i === idx ? __assign(__assign({}, it), { description: e.target.value }) : it;
                                                }) }));
                                        }, sx: inputSx }), block.type === "gallery" && (_jsx(Box, { children: item.imageUrl ? (_jsxs(Box, { sx: {
                                                position: "relative",
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                                border: "1px solid ".concat(ACCENT_BORDER),
                                            }, children: [_jsx("img", { src: item.imageUrl, alt: (_d = item.title) !== null && _d !== void 0 ? _d : "", style: { width: "100%", maxHeight: 140, objectFit: "cover", display: "block" } }), _jsx(Button, { size: "small", onClick: function () {
                                                        var _a;
                                                        return onChange(__assign(__assign({}, block), { items: ((_a = block.items) !== null && _a !== void 0 ? _a : []).map(function (it, i) {
                                                                return i === idx ? __assign(__assign({}, it), { imageUrl: null }) : it;
                                                            }) }));
                                                    }, sx: {
                                                        position: "absolute",
                                                        top: 4,
                                                        right: 4,
                                                        background: "rgba(0,0,0,0.6)",
                                                        color: "#fff",
                                                        fontSize: 10,
                                                        textTransform: "none",
                                                        "&:hover": { background: "rgba(0,0,0,0.8)" },
                                                    }, children: "Remove" })] })) : (_jsxs(Box, { component: "label", sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                border: "1.5px dashed ".concat(BORDER),
                                                borderRadius: "8px",
                                                py: 2,
                                                color: "rgba(255,255,255,0.4)",
                                                fontSize: 11,
                                                "&:hover": { borderColor: ACCENT_BORDER, color: ACCENT },
                                            }, children: ["Upload card image", _jsx("input", { type: "file", accept: ADMIN_IMAGE_ACCEPT, hidden: true, onChange: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                                        var f, url;
                                                        var _a, _b;
                                                        return __generator(this, function (_c) {
                                                            switch (_c.label) {
                                                                case 0:
                                                                    f = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                                                                    if (!f)
                                                                        return [2 /*return*/];
                                                                    return [4 /*yield*/, fileToDataUrl(f)];
                                                                case 1:
                                                                    url = _c.sent();
                                                                    onChange(__assign(__assign({}, block), { items: ((_b = block.items) !== null && _b !== void 0 ? _b : []).map(function (it, i) {
                                                                            return i === idx ? __assign(__assign({}, it), { imageUrl: url }) : it;
                                                                        }) }));
                                                                    e.target.value = "";
                                                                    return [2 /*return*/];
                                                            }
                                                        });
                                                    }); } })] })) }))] }, item.id));
                        }) })] })), (block.type === "image" || block.type === "hero") && (_jsx(Box, { children: block.imageUrl ? (_jsxs(Box, { sx: {
                        position: "relative",
                        borderRadius: "10px",
                        overflow: "hidden",
                        border: "1px solid ".concat(ACCENT_BORDER),
                    }, children: [_jsx("img", { src: block.imageUrl, alt: block.title, style: { width: "100%", maxHeight: 180, objectFit: "cover", display: "block" } }), _jsx(Button, { size: "small", onClick: function () { return onChange(__assign(__assign({}, block), { imageUrl: null })); }, sx: {
                                position: "absolute",
                                top: 6,
                                right: 6,
                                background: "rgba(0,0,0,0.6)",
                                color: "#fff",
                                fontSize: 11,
                                textTransform: "none",
                                "&:hover": { background: "rgba(0,0,0,0.8)" },
                            }, children: "Remove" })] })) : (_jsxs(Box, { component: "label", sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        border: "1.5px dashed ".concat(BORDER),
                        borderRadius: "10px",
                        py: 3,
                        color: "rgba(255,255,255,0.4)",
                        fontSize: 12,
                        "&:hover": { borderColor: ACCENT_BORDER, color: ACCENT },
                    }, children: ["Upload image", _jsx("input", { type: "file", accept: ADMIN_IMAGE_ACCEPT, hidden: true, onChange: function (e) {
                                var _a;
                                var f = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                                if (f)
                                    handleImage(f);
                                e.target.value = "";
                            } })] })) }))] }));
};
var StepAbout = function (_a) {
    var form = _a.form, setForm = _a.setForm, collectionId = _a.collectionId, aboutTexts = _a.aboutTexts, setAboutTexts = _a.setAboutTexts, aboutBlockFiles = _a.aboutBlockFiles, setAboutBlockFile = _a.setAboutBlockFile, aboutSlotFiles = _a.aboutSlotFiles, setAboutSlotFile = _a.setAboutSlotFile;
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2.5, children: [_jsx(TextField, { fullWidth: true, label: "Short description", placeholder: "One-paragraph summary shown on the collection card", value: form.description, onChange: function (e) { return setForm(function (f) { return (__assign(__assign({}, f), { description: e.target.value })); }); }, multiline: true, rows: 3, sx: inputSx }), collectionId ? (_jsx(AboutEditor, { collectionId: collectionId })) : (_jsx(AboutDraftEditor, { texts: aboutTexts, onTextsChange: setAboutTexts, blockFiles: aboutBlockFiles, onBlockFile: setAboutBlockFile, slotFiles: aboutSlotFiles, onSlotFile: setAboutSlotFile }))] }));
};
var StepItems = function (_a) {
    var collectionId = _a.collectionId, itemCount = _a.itemCount, totalSupply = _a.totalSupply, onManage = _a.onManage, pendingItems = _a.pendingItems, onUpdateItem = _a.onUpdateItem, onSetItemImage = _a.onSetItemImage;
    var isEditing = !!collectionId;
    var _b = useState(null), syncJobId = _b[0], setSyncJobId = _b[1];
    var _c = useEnqueueJob(), enqueueJob = _c.mutate, queuing = _c.isPending;
    var handleSyncFromChain = function () {
        if (!collectionId)
            return;
        enqueueJob({
            type: "sync-from-chain",
            collectionId: collectionId,
            total: totalSupply || 100,
            message: "Reading tokenURI from contract…",
            tickMs: 700,
        }, { onSuccess: function (job) { return setSyncJobId(job.id); } });
    };
    if (!isEditing) {
        // Кол-во NFT фиксировано полем Total supply (шаг «Детали»). Слоты
        // пред-сгенерированы ровно под это число (родитель синхронизирует длину) —
        // добавить/удалить нельзя, tokenIndex проставляется бэкендом автоматически.
        var target = pendingItems.length;
        return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [_jsxs(Box, { children: [_jsx(Typography, { sx: { color: "#fff", fontWeight: 700, fontSize: 15 }, children: "NFT items" }), _jsxs(Typography, { sx: { color: "rgba(255,255,255,0.45)", fontSize: 12 }, children: ["\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0440\u043E\u0432\u043D\u043E ", target, " NFT (\u0438\u043C\u044F + \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430 \u0443 \u043A\u0430\u0436\u0434\u043E\u0433\u043E). \u041F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438 \u043E\u043D\u0438 \u0431\u0443\u0434\u0443\u0442 \u0437\u0430\u043C\u0438\u043D\u0447\u0435\u043D\u044B on-chain. Token index \u2014 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438."] })] }), target === 0 && (_jsx(Box, { sx: {
                        border: "1.5px dashed ".concat(BORDER),
                        borderRadius: "12px",
                        py: 5,
                        textAlign: "center",
                        color: "rgba(255,255,255,0.3)",
                        fontSize: 13,
                    }, children: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 Total supply \u043D\u0430 \u0448\u0430\u0433\u0435 \u00AB\u0414\u0435\u0442\u0430\u043B\u0438\u00BB \u2014 \u0441\u043B\u043E\u0442\u044B NFT \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438." })), pendingItems.map(function (item, index) { return (_jsxs(Box, { sx: {
                        display: "grid",
                        gridTemplateColumns: "64px 1fr",
                        gap: 1.5,
                        alignItems: "center",
                        p: 1.25,
                        borderRadius: "12px",
                        background: "rgba(255,255,255,0.02)",
                        border: "1px solid ".concat(BORDER),
                    }, children: [_jsxs(Box, { component: "label", sx: {
                                width: 64,
                                height: 64,
                                borderRadius: "10px",
                                overflow: "hidden",
                                cursor: "pointer",
                                background: ACCENT_BG,
                                border: "1px solid ".concat(ACCENT_BORDER),
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }, children: [item.previewUrl ? (_jsx("img", { src: item.previewUrl, alt: item.name, style: { width: "100%", height: "100%", objectFit: "cover" } })) : (_jsx(ListAltIcon, { sx: { fontSize: 22, color: ACCENT } })), _jsx("input", { type: "file", accept: "image/png,image/jpeg,image/webp", hidden: true, onChange: function (e) {
                                        var _a, _b;
                                        var file = (_b = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
                                        onSetItemImage(item.id, file);
                                        e.target.value = "";
                                    } })] }), _jsx(TextField, { size: "small", placeholder: "NFT name #".concat(index + 1), value: item.name, onChange: function (e) { return onUpdateItem(item.id, { name: e.target.value }); }, sx: inputSx })] }, item.id)); })] }));
    }
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 3, children: [_jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [_jsx(Box, { sx: {
                            width: 56,
                            height: 56,
                            borderRadius: "14px",
                            background: ACCENT_BG,
                            border: "1px solid ".concat(ACCENT_BORDER),
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }, children: _jsx(ListAltIcon, { sx: { fontSize: 28, color: ACCENT } }) }), _jsxs(Box, { flex: 1, children: [_jsx(Typography, { sx: { color: "#fff", fontWeight: 700, fontSize: 17 }, children: "Items Management" }), _jsxs(Typography, { sx: { color: "rgba(255,255,255,0.45)", fontSize: 13 }, children: [itemCount !== null && itemCount !== void 0 ? itemCount : 0, " item", itemCount === 1 ? "" : "s", " in this collection", totalSupply ? " \u00B7 target supply ".concat(totalSupply) : ""] })] })] }), _jsxs(Box, { sx: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }, children: [_jsxs(Box, { sx: {
                            background: "rgba(255,255,255,0.02)",
                            border: "1px solid ".concat(BORDER),
                            borderRadius: "14px",
                            p: 2.5,
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                        }, children: [_jsx(Typography, { sx: { color: "#fff", fontWeight: 600, fontSize: 14 }, children: "Manual / Bulk upload" }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.45)", fontSize: 12, flex: 1 }, children: "Add NFTs one by one or upload JSON/CSV file with multiple items. Useful when you have curated metadata." }), _jsx(Button, { variant: "contained", startIcon: _jsx(ListAltIcon, {}), onClick: onManage, sx: {
                                    background: ACCENT,
                                    color: "#fff",
                                    borderRadius: "10px",
                                    fontWeight: 600,
                                    fontSize: 13,
                                    textTransform: "none",
                                    "&:hover": { background: "rgb(229,149,0)" },
                                }, children: "Open NFT Manager" })] }), _jsxs(Box, { sx: {
                            background: "rgba(255,255,255,0.02)",
                            border: "1px solid ".concat(BORDER),
                            borderRadius: "14px",
                            p: 2.5,
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                        }, children: [_jsx(Typography, { sx: { color: "#fff", fontWeight: 600, fontSize: 14 }, children: "Sync from contract" }), _jsxs(Typography, { sx: { color: "rgba(255,255,255,0.45)", fontSize: 12, flex: 1 }, children: ["Background job that reads ", _jsx("code", { children: "tokenURI" }), " from each token, pulls image + traits, and creates items automatically."] }), _jsx(Button, { variant: "outlined", startIcon: _jsx(SwapHorizIcon, {}), onClick: handleSyncFromChain, disabled: queuing || !!syncJobId, sx: {
                                    borderColor: ACCENT_BORDER,
                                    color: ACCENT,
                                    borderRadius: "10px",
                                    fontWeight: 600,
                                    fontSize: 13,
                                    textTransform: "none",
                                    "&:hover": { borderColor: ACCENT, background: ACCENT_BG },
                                    "&.Mui-disabled": { color: "rgba(255,255,255,0.25)" },
                                }, children: syncJobId ? "Sync running…" : queuing ? "Queueing…" : "Start sync" })] })] }), syncJobId && (_jsx(JobProgress, { jobId: syncJobId, label: "Syncing items from contract", onDone: function () { return undefined; } }))] }));
};
// ── Step 6: Auction ──────────────────────────────────────────────────────────
var StepAuction = function (_a) {
    var _b, _c;
    var form = _a.form, setForm = _a.setForm, collectionId = _a.collectionId;
    var existingAuctions = useAuctionsByCollection(collectionId !== null && collectionId !== void 0 ? collectionId : "").data;
    var coins = useAdminCoins().data;
    // Токен оплаты коллекции — в нём задаются ставка и цена публичной продажи (не $).
    var token = (_c = (_b = coins === null || coins === void 0 ? void 0 : coins.find(function (c) { return c.id === form.paymentCoinId; })) === null || _b === void 0 ? void 0 : _b.symbol) !== null && _c !== void 0 ? _c : "";
    var setAuctionField = function (k) {
        return function (e) {
            return setForm(function (f) {
                var _a;
                return (__assign(__assign({}, f), { auctionData: __assign(__assign({}, f.auctionData), (_a = {}, _a[k] = e.target.value, _a)) }));
            });
        };
    };
    var setAuctionValue = function (k, value) {
        return setForm(function (f) {
            var _a;
            return (__assign(__assign({}, f), { auctionData: __assign(__assign({}, f.auctionData), (_a = {}, _a[k] = value, _a)) }));
        });
    };
    // Тип AUCTION → аукцион обязателен (без тоггла, конфиг всегда виден).
    var isAuctionType = form.type === "AUCTION";
    var startNow = form.auctionData.startNow;
    // Текущий момент для отображения в инпуте «Starts at» при «старте сейчас».
    // Ленивый init (раз при монтировании) — чтобы не вызывать Date.now() в рендере.
    var nowLocalInput = useState(function () {
        return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .slice(0, 16);
    })[0];
    var setStartNow = function (checked) {
        return setForm(function (f) { return (__assign(__assign({}, f), { auctionData: __assign(__assign({}, f.auctionData), { startNow: checked }) })); });
    };
    // Лимит NFT на участника: от 1 до общего числа элементов коллекции (Total Supply).
    var totalSupplyNum = Math.max(1, Math.floor(Number(form.totalSupply) || 1));
    var setAllocation = function (raw) {
        if (raw === "") {
            setAuctionValue("allocationPerBidderMax", "");
            return;
        }
        var n = Math.floor(Number(raw));
        if (!Number.isFinite(n))
            return;
        var clamped = Math.min(totalSupplyNum, Math.max(1, n));
        setAuctionValue("allocationPerBidderMax", String(clamped));
    };
    var startsBeforeEnds = startNow ||
        !form.auctionData.startsAt ||
        !form.auctionData.endsAt ||
        new Date(form.auctionData.startsAt).getTime() <
            new Date(form.auctionData.endsAt).getTime();
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 3, children: [_jsxs(Box, { sx: {
                    background: "rgba(255,255,255,0.02)",
                    border: "1px solid ".concat(form.createAuction || isAuctionType ? ACCENT_BORDER : BORDER),
                    borderRadius: "14px",
                    p: 2.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    transition: "border-color 200ms, box-shadow 200ms",
                    boxShadow: form.createAuction || isAuctionType ? "0 0 0 3px ".concat(ACCENT_BG) : "none",
                }, children: [_jsx(Box, { sx: {
                            width: 48,
                            height: 48,
                            borderRadius: "12px",
                            background: ACCENT_BG,
                            border: "1px solid ".concat(ACCENT_BORDER),
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }, children: _jsx(RocketLaunchIcon, { sx: { color: ACCENT, fontSize: 24 } }) }), _jsxs(Box, { flex: 1, children: [_jsx(Typography, { sx: { color: "#fff", fontWeight: 700, fontSize: 15 }, children: isAuctionType ? "Auction settings (required)" : "Create initial auction" }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.45)", fontSize: 12, mt: 0.25 }, children: isAuctionType
                                    ? "Тип коллекции — AUCTION, поэтому аукцион обязателен. Заполните настройки ниже."
                                    : "An auction will be created and linked to this collection right after publishing. Toggle off to skip — you can always create an auction later from the Auctions page." })] }), !isAuctionType && (_jsx(FormControlLabel, { control: _jsx(Switch, { checked: form.createAuction, onChange: function (e) {
                                return setForm(function (f) { return (__assign(__assign({}, f), { createAuction: e.target.checked })); });
                            }, sx: {
                                "& .MuiSwitch-switchBase.Mui-checked": { color: ACCENT },
                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                    background: ACCENT,
                                },
                            } }), label: "", sx: { m: 0 } }))] }), (form.createAuction || isAuctionType) && (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2.5, children: [_jsxs(Box, { sx: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }, children: [_jsx(TextField, { type: "number", label: "Minimum bid".concat(token ? " (".concat(token, ")") : ""), value: form.auctionData.minBidUsd, onChange: setAuctionField("minBidUsd"), required: true, slotProps: {
                                    input: token
                                        ? { endAdornment: _jsx(InputAdornment, { position: "end", children: token }) }
                                        : undefined,
                                }, sx: inputSx }), _jsx(TextField, { type: "number", label: "Public sale price".concat(token ? " (".concat(token, ")") : ""), value: form.auctionData.publicSalePriceUsd, onChange: setAuctionField("publicSalePriceUsd"), required: true, slotProps: {
                                    input: token
                                        ? { endAdornment: _jsx(InputAdornment, { position: "end", children: token }) }
                                        : undefined,
                                }, sx: inputSx })] }), _jsx(Box, { sx: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }, children: _jsx(TextField, { type: "number", label: "Max allocation per bidder", value: form.auctionData.allocationPerBidderMax, onChange: function (e) { return setAllocation(e.target.value); }, onBlur: function (e) { return setAllocation(e.target.value || "1"); }, inputProps: { min: 1, max: totalSupplyNum }, slotProps: {
                                input: {
                                    endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(Button, { size: "small", onClick: function () { return setAuctionValue("allocationPerBidderMax", String(totalSupplyNum)); }, sx: { minWidth: 0, color: ACCENT, fontWeight: 700, textTransform: "none" }, children: "MAX" }) })),
                                },
                            }, helperText: "\u041E\u0442 1 \u0434\u043E ".concat(totalSupplyNum, " (Total Supply \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438)"), sx: inputSx }) }), _jsx(FormControlLabel, { control: _jsx(Switch, { checked: startNow, onChange: function (e) { return setStartNow(e.target.checked); }, sx: {
                                "& .MuiSwitch-switchBase.Mui-checked": { color: ACCENT },
                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { background: ACCENT },
                            } }), label: _jsx(Typography, { sx: { color: "rgba(255,255,255,0.8)", fontSize: 13 }, children: "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u0430\u0442\u044C \u0430\u0443\u043A\u0446\u0438\u043E\u043D \u0432 \u043C\u043E\u043C\u0435\u043D\u0442 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438" }), sx: { m: 0 } }), _jsxs(Box, { sx: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }, children: [_jsx(AdminDateTimeField, { label: "Starts at", value: startNow ? nowLocalInput : form.auctionData.startsAt, onChange: function (value) { return setAuctionValue("startsAt", value); }, mode: "datetime", disabled: startNow, helperText: startNow ? "Старт в момент создания" : "Нельзя выбрать прошедшее время", sx: inputSx }), _jsx(AdminDateTimeField, { label: "Ends at", value: form.auctionData.endsAt, onChange: function (value) { return setAuctionValue("endsAt", value); }, mode: "datetime", error: !startsBeforeEnds, helperText: !startsBeforeEnds ? "End must be after start" : undefined, sx: inputSx })] })] })), collectionId && existingAuctions && existingAuctions.length > 0 && (_jsxs(Box, { sx: {
                    background: "rgba(255,255,255,0.02)",
                    border: "1px solid ".concat(BORDER),
                    borderRadius: "14px",
                    p: 2,
                }, children: [_jsxs(Typography, { sx: { color: "rgba(255,255,255,0.65)", fontSize: 13, fontWeight: 600, mb: 1 }, children: ["Existing auctions for this collection (", existingAuctions.length, ")"] }), _jsx(Box, { display: "flex", flexDirection: "column", gap: 1, children: existingAuctions.map(function (a) { return (_jsxs(Box, { sx: {
                                display: "grid",
                                gridTemplateColumns: "90px 1fr 100px 130px",
                                gap: 1.5,
                                alignItems: "center",
                                px: 1.5,
                                py: 1,
                                background: "rgba(255,255,255,0.02)",
                                border: "1px solid ".concat(BORDER),
                                borderRadius: "8px",
                            }, children: [_jsx(Chip, { label: a.status, size: "small", sx: {
                                        background: ACCENT_BG,
                                        color: ACCENT,
                                        border: "1px solid ".concat(ACCENT_BORDER),
                                        fontSize: 10,
                                        fontWeight: 600,
                                        height: 18,
                                        textTransform: "uppercase",
                                        width: "fit-content",
                                    } }), _jsxs(Typography, { sx: { color: "#fff", fontSize: 12 }, children: ["$", a.minBidUsd, " \u2192 $", a.publicSalePriceUsd, " \u00B7 supply ", a.totalSupply] }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.4)", fontSize: 11 }, children: new Date(a.startsAt).toLocaleDateString() }), _jsx(Typography, { sx: {
                                        color: "rgba(255,255,255,0.3)",
                                        fontSize: 10,
                                        fontFamily: "monospace",
                                    }, children: a.id.slice(0, 8) })] }, a.id)); }) })] }))] }));
};
// ── Step 7: Publish ───────────────────────────────────────────────────────────
var StepPublish = function (_a) {
    var form = _a.form, bannerPreview = _a.bannerPreview, logoPreview = _a.logoPreview, _b = _a.stagedItemsCount, stagedItemsCount = _b === void 0 ? 0 : _b, paymentTokenLabel = _a.paymentTokenLabel;
    var tokenSym = paymentTokenLabel.split(" — ")[0] || "";
    var suffix = tokenSym ? " ".concat(tokenSym) : "";
    var auctionSummary = form.createAuction
        ? "Min ".concat(form.auctionData.minBidUsd || "—").concat(suffix, " \u2192 Public ").concat(form.auctionData.publicSalePriceUsd || "—").concat(suffix, " \u00B7 supply ").concat(form.totalSupply || "—")
        : "Skipped";
    var summaryRows = [
        { label: "Name", value: form.name || "—" },
        { label: "Slug", value: form.slug ? "/".concat(form.slug) : "—", mono: true },
        { label: "Blockchain", value: form.blockchain, capitalize: true },
        { label: "Category", value: form.category, capitalize: true },
        { label: "Total Supply", value: form.totalSupply || "—" },
        { label: "Токен оплаты", value: paymentTokenLabel || "—" },
        { label: "Verified", value: form.verified ? "Yes" : "No" },
        { label: "Website", value: form.website || "—" },
        { label: "Twitter", value: form.twitter || "—" },
        { label: "Discord", value: form.discord || "—" },
        { label: "NFT items", value: stagedItemsCount > 0 ? "".concat(stagedItemsCount, " to create") : "—" },
        { label: "Initial auction", value: auctionSummary },
    ];
    var isReady = !!(form.name && form.slug && form.paymentCoinId);
    return (_jsxs(Box, { sx: { display: "grid", gridTemplateColumns: "1fr 320px", gap: 3, alignItems: "start" }, children: [_jsxs(Box, { children: [_jsx(Typography, { sx: { color: "rgba(255,255,255,0.65)", fontWeight: 600, fontSize: 13, mb: 2 }, children: "Review Summary" }), _jsx(Box, { sx: { display: "flex", flexDirection: "column", gap: 1 }, children: summaryRows.map(function (_a) {
                            var label = _a.label, value = _a.value, mono = _a.mono, capitalize = _a.capitalize;
                            return (_jsxs(Box, { sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    px: 2,
                                    py: 1.25,
                                    background: "rgba(255,255,255,0.02)",
                                    border: "1px solid ".concat(BORDER),
                                    borderRadius: "10px",
                                }, children: [_jsx(Typography, { sx: { color: "rgba(255,255,255,0.35)", fontSize: 12, width: 130, flexShrink: 0 }, children: label }), _jsx(Typography, { sx: {
                                            color: "#fff",
                                            fontSize: 13,
                                            fontWeight: 500,
                                            fontFamily: mono ? "monospace" : "inherit",
                                            textTransform: capitalize ? "capitalize" : "none",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }, children: value })] }, label));
                        }) })] }), _jsxs(Box, { children: [_jsx(Typography, { sx: { color: "rgba(255,255,255,0.65)", fontWeight: 600, fontSize: 13, mb: 2 }, children: "Preview" }), _jsx(LivePreview, { form: form, bannerPreview: bannerPreview, logoPreview: logoPreview }), !isReady && (_jsx(Alert, { severity: "warning", sx: {
                            mt: 2,
                            background: "rgba(245,158,11,0.08)",
                            color: "#F59E0B",
                            border: "1px solid rgba(245,158,11,0.3)",
                            borderRadius: "12px",
                            fontSize: 12,
                            "& .MuiAlert-icon": { color: "#F59E0B" },
                        }, children: "\u041F\u0435\u0440\u0435\u0434 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0435\u0439 \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435, slug \u0438 \u0442\u043E\u043A\u0435\u043D \u043E\u043F\u043B\u0430\u0442\u044B \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438." }))] })] }));
};
// ── Main Wizard ───────────────────────────────────────────────────────────────
export var CollectionWizard = function () {
    var id = useParams().id;
    var navigate = useNavigate();
    var isEdit = !!id;
    var _a = useState(0), step = _a[0], setStep = _a[1];
    var _b = useState(DEFAULT_FORM), form = _b[0], setForm = _b[1];
    var _c = useState("idle"), slugStatus = _c[0], setSlugStatus = _c[1];
    var _d = useState(null), bannerFile = _d[0], setBannerFile = _d[1];
    var _e = useState(null), logoFile = _e[0], setLogoFile = _e[1];
    var _f = useState(null), bannerPreview = _f[0], setBannerPreview = _f[1];
    var _g = useState(null), logoPreview = _g[0], setLogoPreview = _g[1];
    // About draft (create mode only): texts + staged image files, flushed to the
    // backend after the collection is created.
    var _h = useState(EMPTY_ABOUT), aboutTexts = _h[0], setAboutTexts = _h[1];
    var _j = useState({
        block2: null,
        block3: null,
        block4: null,
    }), aboutBlockFiles = _j[0], setAboutBlockFiles = _j[1];
    var _k = useState([null, null, null]), aboutSlotFiles = _k[0], setAboutSlotFiles = _k[1];
    var setAboutBlockFile = function (key, file) {
        return setAboutBlockFiles(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = file, _a)));
        });
    };
    var setAboutSlotFile = function (index, file) {
        return setAboutSlotFiles(function (prev) {
            var next = __spreadArray([], prev, true);
            next[index] = file;
            return next;
        });
    };
    // PUT texts + upload each staged image. Best-effort: the collection already
    // exists, so About failures must not block the create flow.
    var flushAbout = function (collectionId) { return __awaiter(void 0, void 0, void 0, function () {
        var hasAbout, blockUploads, _i, blockUploads_1, _a, n, file, i, file, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    hasAbout = JSON.stringify(aboutTexts) !== JSON.stringify(EMPTY_ABOUT) ||
                        aboutBlockFiles.block2 ||
                        aboutBlockFiles.block3 ||
                        aboutBlockFiles.block4 ||
                        aboutSlotFiles.some(Boolean);
                    if (!hasAbout)
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 11, , 12]);
                    return [4 /*yield*/, aboutAdminApi.putAll(collectionId, aboutTexts)];
                case 2:
                    _c.sent();
                    blockUploads = [
                        [2, aboutBlockFiles.block2],
                        [3, aboutBlockFiles.block3],
                        [4, aboutBlockFiles.block4],
                    ];
                    _i = 0, blockUploads_1 = blockUploads;
                    _c.label = 3;
                case 3:
                    if (!(_i < blockUploads_1.length)) return [3 /*break*/, 6];
                    _a = blockUploads_1[_i], n = _a[0], file = _a[1];
                    if (!file) return [3 /*break*/, 5];
                    return [4 /*yield*/, aboutAdminApi.setBlockImage(collectionId, n, file)];
                case 4:
                    _c.sent();
                    _c.label = 5;
                case 5:
                    _i++;
                    return [3 /*break*/, 3];
                case 6:
                    i = 0;
                    _c.label = 7;
                case 7:
                    if (!(i < 3)) return [3 /*break*/, 10];
                    file = aboutSlotFiles[i];
                    if (!file) return [3 /*break*/, 9];
                    return [4 /*yield*/, aboutAdminApi.setBlock5Slot(collectionId, (i + 1), file)];
                case 8:
                    _c.sent();
                    _c.label = 9;
                case 9:
                    i += 1;
                    return [3 /*break*/, 7];
                case 10: return [3 /*break*/, 12];
                case 11:
                    _b = _c.sent();
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    // NFT items staged during creation, flushed once the collection has an id.
    var _l = useState([]), pendingItems = _l[0], setPendingItems = _l[1];
    // Кол-во слотов NFT строго равно Total supply (п.11): добавить/удалить нельзя,
    // создаётся ровно столько, сколько указано. Синхронизируем длину массива при
    // изменении totalSupply (только в режиме создания — при редактировании items
    // управляются отдельным менеджером).
    useEffect(function () {
        if (id)
            return;
        var target = Math.max(0, Math.min(500, Math.floor(Number(form.totalSupply) || 0)));
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setPendingItems(function (prev) {
            if (prev.length === target)
                return prev;
            if (prev.length < target) {
                var additions = Array.from({ length: target - prev.length }, function () { return ({
                    id: crypto.randomUUID(),
                    name: "",
                    tokenId: "",
                    imageFile: null,
                    previewUrl: null,
                }); });
                return __spreadArray(__spreadArray([], prev, true), additions, true);
            }
            prev.slice(target).forEach(function (it) { return it.previewUrl && URL.revokeObjectURL(it.previewUrl); });
            return prev.slice(0, target);
        });
    }, [form.totalSupply, id]);
    var updatePendingItem = function (itemId, patch) {
        return setPendingItems(function (prev) {
            return prev.map(function (item) { return (item.id === itemId ? __assign(__assign({}, item), patch) : item); });
        });
    };
    var setPendingItemImage = function (itemId, file) {
        return setPendingItems(function (prev) {
            return prev.map(function (item) {
                if (item.id !== itemId)
                    return item;
                if (item.previewUrl)
                    URL.revokeObjectURL(item.previewUrl);
                return __assign(__assign({}, item), { imageFile: file, previewUrl: file ? URL.createObjectURL(file) : null });
            });
        });
    };
    // Создаём РОВНО столько NFT, сколько слотов (= Total supply). Пустое имя
    // автозаполняется «{collection} #N». tokenIndex не передаём — бэкенд проставит
    // его автоматически последовательно (п.10).
    var flushItems = function (collectionId) { return __awaiter(void 0, void 0, void 0, function () {
        var items, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    items = pendingItems.map(function (item, i) { return ({
                        name: item.name.trim() || "".concat(form.name, " #").concat(i + 1),
                        image: item.imageFile,
                    }); });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, nftsAdminApi.createSlots(collectionId, items)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var _m = useAdminCollection(id !== null && id !== void 0 ? id : ""), existing = _m.data, loadingExisting = _m.isLoading;
    var coins = useAdminCoins().data;
    var _o = useCreateCollection(), create = _o.mutate, creating = _o.isPending;
    var _p = useUpdateCollection(), update = _p.mutate, updating = _p.isPending;
    var selectedCoin = (coins !== null && coins !== void 0 ? coins : []).find(function (c) { return c.id === form.paymentCoinId; });
    var paymentTokenLabel = selectedCoin ? "".concat(selectedCoin.symbol, " \u2014 ").concat(selectedCoin.name) : "";
    useEffect(function () {
        if (!existing)
            return;
        // Подгрузка существующей коллекции в форму при редактировании — намеренно.
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setForm(function (prev) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return (__assign(__assign({}, prev), { name: existing.name, slug: existing.slug, creatorId: (_a = existing.creatorId) !== null && _a !== void 0 ? _a : null, creatorName: (_b = existing.creatorName) !== null && _b !== void 0 ? _b : "", creatorVerified: !!existing.creatorVerified, royaltyPercent: existing.royaltyPercent != null && existing.royaltyPercent > 0
                    ? String(existing.royaltyPercent)
                    : "", paymentCoinId: (_c = existing.paymentCoinId) !== null && _c !== void 0 ? _c : "", blockchain: existing.blockchain, contractAddress: existing.contractAddress, tokenStandard: existing.tokenStandard, mintDate: (_d = existing.mintDate) !== null && _d !== void 0 ? _d : "", totalSupply: existing.totalSupply != null ? String(existing.totalSupply) : "", category: existing.category, region: (_e = existing.region) !== null && _e !== void 0 ? _e : "", country: (_f = existing.country) !== null && _f !== void 0 ? _f : "", latitude: existing.latitude != null ? String(existing.latitude) : "", longitude: existing.longitude != null ? String(existing.longitude) : "", type: existing.type, verified: existing.verified, description: (_g = existing.description) !== null && _g !== void 0 ? _g : "", website: (_h = existing.website) !== null && _h !== void 0 ? _h : "", twitter: (_j = existing.twitter) !== null && _j !== void 0 ? _j : "", discord: (_k = existing.discord) !== null && _k !== void 0 ? _k : "", instagram: (_l = existing.instagram) !== null && _l !== void 0 ? _l : "", aboutBlocks: (_m = existing.aboutBlocks) !== null && _m !== void 0 ? _m : [] }));
        });
        if (existing.bannerUrl)
            setBannerPreview(existing.bannerUrl);
        if (existing.logoUrl)
            setLogoPreview(existing.logoUrl);
    }, [existing]);
    var _q = useCreateAuction(), createAuctionMutation = _q.mutate, creatingAuction = _q.isPending;
    var buildFormData = function (overrideStatus) {
        var fd = new FormData();
        Object.keys(form).forEach(function (k) {
            // These wizard-only fields aren't part of the collection model
            if (k === "createAuction" || k === "auctionData")
                return;
            var v = form[k];
            if (v === null || v === undefined)
                return;
            if (k === "aboutBlocks") {
                fd.append("aboutBlocks", JSON.stringify(v));
                return;
            }
            fd.append(k, String(v));
        });
        if (overrideStatus)
            fd.append("status", overrideStatus);
        if (bannerFile)
            fd.append("banner", bannerFile);
        if (logoFile)
            fd.append("logo", logoFile);
        return fd;
    };
    // Один флаг на весь процесс публикации (create → about → items → auction),
    // чтобы кнопка была заблокирована всё время и не было дабл-клика/дублей.
    var _r = useState(false), isProcessing = _r[0], setIsProcessing = _r[1];
    // Тосты ошибок публикации — чтобы пользователь видел, ПОЧЕМУ не создалось.
    var _s = useToastQueue(3), wizardToasts = _s.toasts, pushWizardToast = _s.push, removeWizardToast = _s.remove;
    var handleSubmitError = function (err) {
        var _a;
        setIsProcessing(false);
        var data = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data;
        var msg = Array.isArray(data === null || data === void 0 ? void 0 : data.message) ? data === null || data === void 0 ? void 0 : data.message[0] : data === null || data === void 0 ? void 0 : data.message;
        pushWizardToast(msg || "Не удалось сохранить коллекцию");
    };
    var maybeCreateAuctionFor = function (collectionId, onDone) {
        // Аукцион обязателен для типа AUCTION; для прочих — по тогглу.
        var mustCreate = form.createAuction || form.type === "AUCTION";
        if (!mustCreate) {
            onDone();
            return;
        }
        var a = form.auctionData;
        var auctionSupply = form.totalSupply;
        // Старт: «сейчас» по чекбоксу, либо выбранное время; просроченное прошлое
        // выставляем на «сейчас» (чтобы старт совпал с публикацией).
        var now = Date.now();
        var startMs = a.startNow ? now : new Date(a.startsAt).getTime();
        if (!a.startNow && (!a.startsAt || Number.isNaN(startMs) || startMs < now)) {
            startMs = now;
        }
        var isValid = a.minBidUsd &&
            a.publicSalePriceUsd &&
            auctionSupply &&
            a.endsAt &&
            form.paymentCoinId &&
            startMs < new Date(a.endsAt).getTime();
        if (!isValid) {
            onDone();
            return;
        }
        createAuctionMutation({
            collectionId: collectionId,
            data: {
                description: a.description,
                settlementModel: a.settlementModel,
                rules: a.rules,
                minBidUsd: a.minBidUsd,
                publicSalePriceUsd: a.publicSalePriceUsd,
                totalSupply: auctionSupply,
                allocationPerBidderMax: a.allocationPerBidderMax || "1",
                startsAt: new Date(startMs).toISOString(),
                endsAt: new Date(a.endsAt).toISOString(),
                paymentMethods: a.paymentMethods,
                // Монета ставки = платёжный токен коллекции (с шага «Детали»).
                bidCoinId: form.paymentCoinId,
            },
        }, { onSettled: onDone });
    };
    var handleSubmit = function () {
        if (isProcessing)
            return;
        if (!isEdit) {
            var requiredChecks = [
                { ok: !!form.name, step: 0, msg: "укажите название коллекции" },
                { ok: !!form.slug, step: 0, msg: "укажите slug" },
                { ok: !!form.paymentCoinId, step: 0, msg: "выберите токен оплаты" },
                { ok: !!logoFile, step: 1, msg: "загрузите логотип" },
                { ok: !!bannerFile, step: 1, msg: "загрузите баннер" },
                {
                    ok: pendingItems.every(function (it) { return it.name.trim() && it.imageFile; }),
                    step: 4,
                    msg: "у каждого NFT нужны имя и картинка",
                },
            ];
            var firstInvalid = requiredChecks.find(function (c) { return !c.ok; });
            if (firstInvalid) {
                setStep(firstInvalid.step);
                pushWizardToast("\u0428\u0430\u0433 \u00AB".concat(STEPS[firstInvalid.step], "\u00BB: ").concat(firstInvalid.msg));
                return;
            }
        }
        setIsProcessing(true);
        var fd = buildFormData("active");
        var finish = function () {
            setIsProcessing(false);
            navigate("/admin/collections");
        };
        if (isEdit && id) {
            update({ id: id, payload: fd }, {
                onSuccess: function () { return maybeCreateAuctionFor(id, finish); },
                onError: handleSubmitError,
            });
        }
        else {
            create(fd, {
                onSuccess: function (created) {
                    return flushAbout(created.id)
                        .then(function () { return flushItems(created.id); })
                        // Создаём реальные NFT on-chain (деплой ERC-721 + mint на hot-wallet).
                        // Фоновая задача на бэке — прогресс виден на странице коллекции.
                        .then(function () {
                        return pendingItems.length > 0
                            ? collectionsAdminApi.mint(created.id).catch(function () { return undefined; })
                            : undefined;
                    })
                        .finally(function () {
                        return maybeCreateAuctionFor(created.id, function () {
                            setIsProcessing(false);
                            navigate("/admin/collections/".concat(created.id));
                        });
                    });
                },
                onError: handleSubmitError,
            });
        }
    };
    var handleSaveChanges = function () {
        if (!isEdit || !id || isProcessing)
            return;
        setIsProcessing(true);
        var fd = buildFormData();
        update({ id: id, payload: fd }, {
            onSuccess: function () {
                setIsProcessing(false);
                navigate("/admin/collections");
            },
            onError: handleSubmitError,
        });
    };
    var isSubmitting = creating || updating || creatingAuction || isProcessing;
    var isLastStep = step === STEPS.length - 1;
    // Валидация данных конкретного шага. null — шаг валиден, иначе текст ошибки
    // для тоста. Применяется при создании (как requiredChecks); в edit — свободно.
    var getStepError = function (s) {
        if (s === 0) {
            if (!form.name.trim())
                return "Укажите название коллекции";
            if (!form.slug.trim())
                return "Укажите slug";
            if (slugStatus === "checking")
                return "Дождитесь проверки slug";
            if (slugStatus === "taken")
                return "Этот slug уже занят";
            if (!isEdit && slugStatus !== "available")
                return "Проверьте доступность slug";
            if (!form.paymentCoinId)
                return "Выберите токен оплаты";
            if (!form.blockchain)
                return "Выберите блокчейн";
            if (!form.category)
                return "Выберите категорию";
            if (!form.contractAddress.trim() && (Number(form.totalSupply) || 0) < 1)
                return "Total supply должен быть ≥ 1";
            return null;
        }
        if (s === 1) {
            if (!logoFile && !logoPreview)
                return "Загрузите логотип";
            if (!bannerFile && !bannerPreview)
                return "Загрузите баннер";
            return null;
        }
        if (s === 4) {
            var bad = pendingItems.findIndex(function (it) { return !it.name.trim() || !it.imageFile; });
            if (bad !== -1)
                return "NFT #".concat(bad + 1, ": \u043D\u0443\u0436\u043D\u044B \u0438\u043C\u044F \u0438 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430");
            return null;
        }
        if (s === 5 && (form.createAuction || form.type === "AUCTION")) {
            var a = form.auctionData;
            if (!a.minBidUsd)
                return "Укажите минимальную ставку";
            if (!a.publicSalePriceUsd)
                return "Укажите цену публичной продажи";
            if (!a.endsAt)
                return "Укажите дату окончания аукциона";
            var startsBeforeEnds = a.startNow ||
                !a.startsAt ||
                new Date(a.startsAt).getTime() < new Date(a.endsAt).getTime();
            if (!startsBeforeEnds)
                return "Старт аукциона должен быть раньше окончания";
            var supply = Math.max(1, Math.floor(Number(form.totalSupply) || 1));
            var alloc = Number(a.allocationPerBidderMax);
            if (!a.allocationPerBidderMax ||
                !Number.isInteger(alloc) ||
                alloc < 1 ||
                alloc > supply)
                return "\u041B\u0438\u043C\u0438\u0442 \u043D\u0430 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430: \u043E\u0442 1 \u0434\u043E ".concat(supply);
            return null;
        }
        return null;
    };
    var handleNext = function () {
        if (!isEdit) {
            var err = getStepError(step);
            if (err) {
                pushWizardToast(err);
                return;
            }
        }
        setStep(function (prev) { return Math.min(prev + 1, STEPS.length - 1); });
    };
    var canJumpToStep = function (targetStep) {
        return isEdit || targetStep <= step || getStepError(step) === null;
    };
    // Шаг «заполнен» = пройден и валиден (зелёная галочка в индикаторе).
    var isStepDone = function (i) { return i < step && getStepError(i) === null; };
    var stepHint = function (i) {
        if (i === step)
            return "Текущий шаг";
        if (isStepDone(i))
            return "Заполнено · нажмите, чтобы вернуться";
        if (canJumpToStep(i))
            return "Нажмите, чтобы перейти";
        return "Сначала заполните текущий шаг";
    };
    // Токен оплаты — обязательное поле; без него нельзя опубликовать/сохранить
    // коллекцию (на шаге «Детали» переход вперёд блокирует getStepError).
    var paymentTokenMissing = !form.paymentCoinId;
    var blockSubmitForPaymentToken = paymentTokenMissing;
    // При СОЗДАНИИ бэкенд требует name, slug, paymentCoinId, logo и banner —
    // без них запрос упадёт. Блокируем публикацию, чтобы не было «зависаний».
    var missingRequiredForCreate = !isEdit &&
        (!form.name ||
            !form.slug ||
            !form.paymentCoinId ||
            !logoFile ||
            !bannerFile ||
            pendingItems.some(function (it) { return !it.name.trim() || !it.imageFile; }));
    var blockSubmit = blockSubmitForPaymentToken || missingRequiredForCreate;
    if (isEdit && loadingExisting) {
        return (_jsx(Box, { display: "flex", justifyContent: "center", py: 10, children: _jsx(CircularProgress, { sx: { color: ACCENT } }) }));
    }
    return (_jsxs(Box, { sx: { maxWidth: 1100, mx: "auto" }, children: [_jsxs(Box, { sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    mb: 3,
                    pb: 2.5,
                    borderBottom: "1px solid ".concat(BORDER),
                }, children: [_jsxs(Box, { children: [_jsxs(Breadcrumbs, { separator: "\u203A", sx: { "& .MuiBreadcrumbs-separator": { color: "rgba(255,255,255,0.25)" } }, children: [_jsx(Typography, { onClick: function () { return navigate("/admin/collections"); }, sx: {
                                            color: "rgba(255,255,255,0.4)",
                                            fontSize: 13,
                                            cursor: "pointer",
                                            "&:hover": { color: ACCENT },
                                            transition: "color 150ms",
                                        }, children: "\u041A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438" }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.65)", fontSize: 13 }, children: isEdit ? "Редактировать коллекцию" : "Создать коллекцию" })] }), _jsx(Typography, { variant: "h5", fontWeight: 700, sx: { color: "#fff", mt: 0.75, letterSpacing: "-0.3px", fontFamily: FONT.heading }, children: isEdit ? "Редактировать коллекцию" : "Создать коллекцию" })] }), _jsx(Avatar, { src: logoPreview !== null && logoPreview !== void 0 ? logoPreview : undefined, sx: {
                            width: 38,
                            height: 38,
                            background: ACCENT_BG,
                            border: "1px solid ".concat(ACCENT_BORDER),
                            mt: 0.5,
                        }, children: _jsx(CollectionsIcon, { sx: { fontSize: 18, color: ACCENT } }) })] }), _jsxs(Box, { sx: {
                    mb: 3,
                    px: 3,
                    py: 2.5,
                    background: BG_CARD,
                    border: "1px solid ".concat(BORDER),
                    borderRadius: "16px",
                }, children: [_jsx(Stepper, { activeStep: step, alternativeLabel: true, sx: {
                            "& .MuiStepIcon-root": { color: BORDER, fontSize: 28 },
                            "& .MuiStepIcon-root.Mui-active": {
                                color: ACCENT,
                                filter: "drop-shadow(0 0 6px ".concat(ACCENT, ")"),
                            },
                            "& .MuiStepIcon-root.Mui-completed": { color: SUCCESS },
                            "& .MuiStepConnector-line": { borderColor: BORDER },
                            "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
                                borderColor: SUCCESS,
                            },
                            "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
                                borderColor: ACCENT_BORDER,
                            },
                            "& .MuiStepLabel-label": {
                                color: "rgba(255,255,255,0.35)",
                                fontSize: 12,
                                mt: 0.5,
                            },
                            "& .MuiStepLabel-label.Mui-active": { color: ACCENT, fontWeight: 700 },
                            "& .MuiStepLabel-label.Mui-completed": { color: SUCCESS },
                        }, children: STEPS.map(function (label, i) { return (_jsx(Step, { completed: isStepDone(i), children: _jsx(Tooltip, { title: stepHint(i), arrow: true, children: _jsx(StepLabel, { onClick: function () {
                                        if (canJumpToStep(i))
                                            setStep(i);
                                    }, sx: {
                                        cursor: canJumpToStep(i) ? "pointer" : "default",
                                        "&:hover .MuiStepLabel-label": canJumpToStep(i)
                                            ? { color: "#fff" }
                                            : undefined,
                                    }, children: label }) }) }, label)); }) }), _jsx(Typography, { sx: {
                            mt: 1.5,
                            textAlign: "center",
                            color: "rgba(255,255,255,0.3)",
                            fontSize: 11.5,
                        }, children: "\u2713 \u0437\u0435\u043B\u0451\u043D\u044B\u043C \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u044B \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0435 \u0448\u0430\u0433\u0438 \u00B7 \u043A\u043B\u0438\u043A\u0430\u0439\u0442\u0435 \u043F\u043E \u0448\u0430\u0433\u0430\u043C, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0430\u0442\u044C\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u043D\u0438\u043C\u0438" })] }), _jsxs(Box, { sx: {
                    background: BG_CARD,
                    border: "1px solid ".concat(BORDER),
                    borderRadius: "24px",
                    px: 4,
                    py: 4,
                    boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
                    minHeight: 320,
                }, children: [_jsxs(Typography, { sx: {
                            color: "rgba(255,255,255,0.35)",
                            fontWeight: 600,
                            fontSize: 11,
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                            mb: 3,
                        }, children: ["\u0428\u0430\u0433 ", step + 1, " \u0438\u0437 ", STEPS.length, " \u2014 ", STEPS[step]] }), step === 0 && (_jsx(StepBasicInfo, { form: form, setForm: setForm, slugStatus: slugStatus, setSlugStatus: setSlugStatus, collectionId: id })), step === 1 && (_jsx(StepMedia, { form: form, bannerPreview: bannerPreview, setBannerFile: setBannerFile, setBannerPreview: setBannerPreview, logoPreview: logoPreview, setLogoFile: setLogoFile, setLogoPreview: setLogoPreview, onInvalidImage: function () { return pushWizardToast(ADMIN_IMAGE_ERROR); } })), step === 2 && _jsx(StepSocials, { form: form, setForm: setForm }), step === 3 && (_jsx(StepAbout, { form: form, setForm: setForm, collectionId: id, aboutTexts: aboutTexts, setAboutTexts: setAboutTexts, aboutBlockFiles: aboutBlockFiles, setAboutBlockFile: setAboutBlockFile, aboutSlotFiles: aboutSlotFiles, setAboutSlotFile: setAboutSlotFile })), step === 4 && (_jsx(StepItems, { collectionId: id, itemCount: existing === null || existing === void 0 ? void 0 : existing.itemCount, totalSupply: existing === null || existing === void 0 ? void 0 : existing.totalSupply, onManage: function () { return id && navigate("/admin/collections/".concat(id, "/nfts")); }, pendingItems: pendingItems, onUpdateItem: updatePendingItem, onSetItemImage: setPendingItemImage })), step === 5 && (_jsx(StepAuction, { form: form, setForm: setForm, collectionId: id })), step === 6 && (_jsx(StepPublish, { form: form, bannerPreview: bannerPreview, logoPreview: logoPreview, stagedItemsCount: pendingItems.length, paymentTokenLabel: paymentTokenLabel }))] }), _jsxs(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3, children: [_jsx(Button, { startIcon: _jsx(ArrowBackIcon, {}), onClick: function () {
                            if (step > 0)
                                setStep(function (s) { return s - 1; });
                            else
                                navigate("/admin/collections");
                        }, sx: {
                            color: "rgba(255,255,255,0.45)",
                            borderRadius: "12px",
                            px: 3,
                            py: 1.25,
                            border: "1px solid ".concat(BORDER),
                            "&:hover": {
                                color: "#fff",
                                borderColor: "rgba(255,255,255,0.25)",
                                background: "rgba(255,255,255,0.04)",
                            },
                        }, children: step === 0 ? "Отмена" : "Назад" }), _jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [_jsx(Box, { display: "flex", gap: 0.75, children: STEPS.map(function (_, i) { return (_jsx(Box, { title: stepHint(i), onClick: function () {
                                        if (canJumpToStep(i))
                                            setStep(i);
                                    }, sx: {
                                        width: i === step ? 20 : 6,
                                        height: 6,
                                        borderRadius: "3px",
                                        background: isStepDone(i)
                                            ? SUCCESS
                                            : i === step
                                                ? ACCENT
                                                : BORDER,
                                        transition: "all 300ms",
                                        cursor: canJumpToStep(i) ? "pointer" : "default",
                                        "&:hover": canJumpToStep(i)
                                            ? { transform: "scaleY(1.8)" }
                                            : undefined,
                                    } }, i)); }) }), isEdit && (_jsx(Button, { onClick: handleSaveChanges, disabled: isSubmitting || blockSubmitForPaymentToken, sx: {
                                    color: "rgba(255,255,255,0.55)",
                                    border: "1px solid ".concat(BORDER),
                                    borderRadius: "12px",
                                    px: 2.5,
                                    py: 1.25,
                                    fontWeight: 600,
                                    fontSize: 14,
                                    textTransform: "none",
                                    "&:hover": { color: "#fff", borderColor: "rgba(255,255,255,0.25)" },
                                }, children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" })), _jsx(Button, { variant: "contained", endIcon: isLastStep ? (_jsx(RocketLaunchIcon, {})) : (_jsx(ArrowForwardIcon, {})), onClick: isLastStep ? handleSubmit : handleNext, disabled: isSubmitting ||
                                    (isEdit && isLastStep) ||
                                    (isLastStep && blockSubmit), sx: {
                                    background: ACCENT,
                                    color: "#fff",
                                    borderRadius: "12px",
                                    px: 3.5,
                                    py: 1.25,
                                    fontWeight: 600,
                                    fontSize: 14,
                                    textTransform: "none",
                                    boxShadow: "0 4px 15px rgba(255,184,1,0.3)",
                                    "&:hover": {
                                        background: "rgb(229,149,0)",
                                        boxShadow: "0 6px 20px rgba(255,184,1,0.4)",
                                    },
                                    "&.Mui-disabled": {
                                        background: "rgba(255,184,1,0.25)",
                                        color: "rgba(255,255,255,0.35)",
                                    },
                                }, children: isSubmitting ? (_jsx(CircularProgress, { size: 18, sx: { color: "#fff" } })) : isLastStep ? (isEdit ? "Далее" : "Опубликовать") : ("Далее") })] })] }), _jsx(ToastStack, { toasts: wizardToasts, remove: removeWizardToast })] }));
};
